import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Deserialize } from 'cerialize';
import { Notification } from '../models/notification';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { Action } from '../models/action';
import { filter, map } from 'rxjs/operators';
import { objectToFormData } from "object-to-formdata";

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  baseApiUrl: string = environment.api.baseUrl;

  protected _notifications: BehaviorSubject<Notification[]> = new BehaviorSubject(null);
  public readonly notifications: Observable<Notification[]> = this._notifications.asObservable().pipe(filter(actions => actions != null));

  constructor(private http: HttpClient) {
  }

  load(): Promise<Notification[]> {
    return this.http.get(`${this.baseApiUrl}notifications`).toPromise().then(data => {
      const notifications = Deserialize(data, Notification);
      this._notifications.next(notifications);
      return notifications;
    });
  }

  countUnread(): Observable<number> {
    return this._notifications.pipe(map(notifications => {
      return notifications ? notifications.filter(notification => notification.readedAt == null).length : 0;
    }));
  }

  /**
   * Attention cette méthode marque la notification comme lue
   * @param notificationId
   */
  findById(notificationId: number): Promise<Notification> {
    return this.http.get(`${this.baseApiUrl}notifications/${notificationId}`).toPromise().then(
      (data) => {
        return Deserialize(data, Notification);
      },
      (data) => {
        throw new Error(`An unexpected error occurred while data loading ${JSON.stringify(data)}`);
      });
  }

  markAsRead(notificationId: number): Promise<Notification> {
    return this.findById(notificationId);
  }

  markAsNotRead(notificationId: number): Promise<Notification> {
    return this.http.get(`${this.baseApiUrl}notifications/mark-as-not-read/${notificationId}`).toPromise().then(
      (data) => {
        return Deserialize(data, Notification);
      },
      (data) => {
        throw new Error(`An unexpected error occurred while data loading ${JSON.stringify(data)}`);
      });

  }

  saveParametrage(parametrage: any): Promise<any> {
    return this.http.post(`${this.baseApiUrl}parametrage-notifications`, objectToFormData(parametrage)).toPromise().then(
      (data) => {
        return data;
      },
      (data) => {
        if (data.status == 400) {
          return data.error;
        }
        throw new Error('An unexpected error occurred while data loading : ' + data);
      });
  }

  loadParametrage(): Promise<any> {
    return this.http.get(`${this.baseApiUrl}parametrage-notifications`).toPromise().then(data => data);
  }
}
